module.exports = __webpack_public_path__ + "img/5.6dd7891d.jpg";